module.exports = __webpack_public_path__ + "img/audio_title.55e73d2d.png";